<template>
  <div class="min-h-screen bg-[#FAFAF8] px-6 py-8">
    <div class="max-w-4xl mx-auto space-y-8">
      <!-- En-tête de la page -->
      <div class="bg-white rounded-2xl shadow-sm p-8 border border-gray-100">
        <h1 class="text-2xl font-extrabold text-[#0B2447]">
          Gestion des Comptes
        </h1>
        <p class="text-gray-500 mt-2 text-sm">
          Bienvenue sur votre espace de gestion des comptes. Vous pourrez y
          administrer vos paramètres, vos profils utilisateurs et vos
          configurations de projets.
        </p>
      </div>

      <!-- Module de Configuration des Catégories -->
      <div class="grid grid-cols-1 gap-8">
        <CategorySettings />
      </div>

      <!-- Profil de l'utilisateur -->
      <ProfileSettings :user="currentUser" @updated="onProfileUpdated" />

      <!-- Sécurité (mot de passe) -->
      <SecuritySettings />
    </div>
  </div>
</template>

<script>
import CategorySettings from './CategorySettings.vue'
import ProfileSettings from './ProfileSettings.vue'
import SecuritySettings from './SecuritySettings.vue'

export default {
  name: 'ComptesView',
  components: {
    CategorySettings,
    ProfileSettings,
    SecuritySettings
  },
  data() {
    return {
      // TODO : remplacer par l'utilisateur réellement connecté (store, API…)
      currentUser: {
        prenom: '',
        nom: '',
        email: '',
        telephone: ''
      }
    }
  },
  methods: {
    onProfileUpdated(profile) {
      // Garde la vue synchronisée avec ce qui vient d'être enregistré
      this.currentUser = { ...profile }
    }
  }
}
</script>

<style scoped>
/* Ajoute ici des styles spécifiques si besoin */
</style>
